import Shepherd from 'shepherd.js';

export default {

    tour(){

        if($('.network-administration-pipelines').length){
    
            ['close', 'cancel', 'complete'].forEach(event => Shepherd.on(event, () => {
                var data = {
                    'page': 'network-administration-pipelines-2'
                };
                axios.post("/api/v1/onboarding", data)
                .then((response) =>  {
                }).catch(function (error) {
                    console.log('onboarding logged')
                });
            }));
    
            var dataType = $('.network-administration-pipelines').attr('data-type');
            
            const tour2 = new Shepherd.Tour({
                defaultStepOptions: {
                    cancelIcon: {
                        enabled: true
                    },
                    classes: 'shepherd-container',
                    scrollTo: { behavior: 'smooth', block: 'center' }
                },
                useModalOverlay: true
            });
            
            tour2.addStep({
                title: 'Changing your stage name',
                text: "You can edit the name of your new stages by clicking the edit button next to their name, typing the new stage name and then pressing enter or clicking the save icon that will have replaced the save icon.",
                buttons: [
                    {
                        action() {
                            return this.next();
                        },
                        classes: 'btn btn--secondary',
                        text: 'Next'
                    }
                ],     
                attachTo: {
                    element: '.pipeline .stage .fa-edit',
                    on: 'right'
                },       
                id: 'step-1'
            });
            
            tour2.addStep({
                title: 'Reorder stages',
                text: "If you want to reorder your stages you'll need to click this button, it will bring up a modal that will allow you to drag and drop your stages into their new order.",
                attachTo: {
                    element: '.header-actions .action',
                    on: 'bottom'
                },
                buttons: [
                    {
                        action() {
                            return this.back();
                        },
                        classes: 'btn btn--border',
                        text: 'Back'
                    },
                    {
                        action() {
                            return this.next();
                        },
                        classes: 'btn btn--secondary',
                        text: 'Next'
                    }
                ],
                id: 'step-2'
            });
            
            tour2.addStep({
                title: 'Removing a stage',
                text: "You can remove a stage whenever you wish by clicking this delete button. You must first make sure that you have moved all applications out of the stage. You'll be asked to confirm if you wish to delete it.",
                attachTo: {
                    element: '.pipeline .stage .fa-trash',
                    on: 'right'
                },
                buttons: [
                    {
                        action() {
                            return this.back();
                        },
                        classes: 'btn btn--border',
                        text: 'Back'
                    },
                    {
                        action() {
                            return this.next();
                        },
                        classes: 'btn btn--secondary',
                        text: 'Next'
                    }
                ],
                id: 'step-3'
            });
            
            tour2.addStep({
                title: 'Adding an application',
                text: "To start adding applications into your pipeline, you'll need to assign them to a stage. You can add this on the individual applications page in the sidebar, or by selecting it from the dropdown list at the footer of the stage. If you have no applications yet, you will not see this dropdown. Please assign an application to a stage to view the next part of this guide.",
                attachTo: {
                    element: '.pipeline .stage .card-footer',
                    on: 'right'
                },
                buttons: [
                    {
                        action() {
                            return this.back();
                        },
                        classes: 'btn btn--border',
                        text: 'Back'
                    },
                    {
                        action() {
                            return this.complete();
                        },
                        classes: 'btn btn--secondary',
                        text: 'Finish'
                    }
                ],
                id: 'step-4'
            });
    
            if(!$('.onboarding-network-administration-pipelines-2').length){
                setTimeout(function(){
                    tour2.start();
                }, 500);
            }
        }
    }
}
